// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 94px;
  background-color: #ffffff;
}

.wrapper-block {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

ion-checkbox {
  --background: transparent;
}

.alert {
  width: 45px;
  height: 45px;
  margin-bottom: 22px;
}

.title {
  font-family: AppFontMedium;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.info::ng-deep {
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  margin-bottom: 16px;
  text-wrap: balance;
}
.info::ng-deep strong {
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  text-wrap: balance;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.block-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 0px;
  cursor: pointer;
}
.block-checkbox ion-checkbox {
  --checkmark-color: #fff;
  --border-color: #1e1e1c;
  --border-color-checked: #1e1e1c;
  --checkbox-background-checked: #1e1e1c;
  pointer-events: none;
  margin-right: 12px;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .block-checkbox ion-checkbox {
    margin-top: -1px;
  }
}
.block-checkbox .age-info {
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  color: #1e1e1c;
}`, "",{"version":3,"sources":["webpack://./src/app/components/confirm-year-dialog/confirm-year-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;AADD;;AAIA;EACC,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADD;;AAIA;EACC,yBAAA;AADD;;AAIA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AADD;;AAIA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AADD;;AAIA;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;AADD;AAGC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AADF;;AAKA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAFD;;AAKA;EACC,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AAFD;AAIC;EACC,uBAAA;EACA,uBAAA;EACA,+BAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAFF;AC7EE;EDwED;IAUE,gBAAA;EADD;AACF;AAIC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAFF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: auto;\n\tpadding-bottom: 94px;\n\tbackground-color: #ffffff;\n}\n\n.wrapper-block {\n\twidth: 100%;\n\tpadding: 16px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\nion-checkbox {\n\t--background: transparent;\n}\n\n.alert {\n\twidth: 45px;\n\theight: 45px;\n\tmargin-bottom: 22px;\n}\n\n.title {\n\tfont-family: AppFontMedium;\n\tfont-size: 24px;\n\tline-height: 100%;\n\tletter-spacing: -0.01em;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tmargin-bottom: 12px;\n}\n\n.info::ng-deep {\n\tfont-size: 12px;\n\tline-height: 135%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\ttext-transform: capitalize;\n\tmargin-bottom: 16px;\n\ttext-wrap: balance;\n\n\tstrong {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: capitalize;\n\t\ttext-wrap: balance;\n\t}\n}\n\n.footer-item {\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tpadding: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.block-checkbox {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tpadding: 10px 0px;\n\tcursor: pointer;\n\n\tion-checkbox {\n\t\t--checkmark-color: #fff;\n\t\t--border-color: #1e1e1c;\n\t\t--border-color-checked: #1e1e1c;\n\t\t--checkbox-background-checked: #1e1e1c;\n\t\tpointer-events: none;\n\t\tmargin-right: 12px;\n\t\tflex-shrink: 0;\n\n\t\t@include mobile {\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n\n\t.age-info {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tcolor: #1e1e1c;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
